import React from "react";
import { AuthenticationInfoType } from "../utility/types";
import getUrl from "../utility/getUrl";
import { Navigate } from "react-router-dom";

interface IProps {
  auth: AuthenticationInfoType;
}

class OrganizationInfo extends React.Component<IProps> {
  state = {
    loading: false,
    error: "",
    organizationId: "",
    organizationName: "",
  };

  handleOk = async () => {
    try {
      const organizationId = this.state.organizationId.trim();
      if (!organizationId) {
        this.setState({
          error: "Please enter organization Id",
        });
        return;
      }

      this.setState({
        loading: true,
      });

      const url = getUrl("organizationNameById", organizationId);
      const options = {
        headers: new Headers({
          Authorization: `Bearer ${this.props.auth.accessToken}`,
        }),
      };
      const result = await fetch(url, options);
      const organizationName = await result.text();
      let error = "";
      if (!result.ok) {
        error = "Organization not found";
        if (result.status === 401) {
          error = "Sorry, you have no access to this service";
        }
      }
      this.setState({
        loading: false,
        error: error,
        organizationName: organizationName,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        loading: false,
        error: "ups - exception",
      });
    }
  };

  handleChange = (ev: any) => {
    this.setState({
      error: "",
      loading: false,
      organizationName: "",
      organizationId: ev.target.value,
    });
  };

  onFocus = (ev: any) => {
    if (ev.target) {
      ev.target.select();
    }
  };

  render() {
    if (!this.props.auth) {
      return <Navigate to="/" />;
    }

    let statusComponent = <div className="output-text--loading">&nbsp;</div>;
    if (this.state.loading) {
      statusComponent = <div className="output-text--loading">Loading ...</div>;
    } else {
      if (this.state.error) {
        statusComponent = <div className="output-text--error">{this.state.error}</div>;
      }
    }

    return (
      <div className="organization-info">
        <h2>Get Organization Name</h2>

        <label>
          <div className="label">Organization Id:</div>
          <input
            className="bottom-border"
            type="text"
            onFocus={this.onFocus}
            value={this.state.organizationId}
            onChange={this.handleChange}
          />
        </label>

        <label>
          <div className="label">Organization Name:</div>
          <div className="output-text"> {this.state.organizationName}</div>
        </label>

        {statusComponent}

        <button className="button" onClick={this.handleOk}>
          Get Name
        </button>
      </div>
    );
  }
}

export default OrganizationInfo;
